// After a deploy, tabs still running the previous build request hashed chunks that no longer
// exist. Reload once to pick up the new index.html; the timestamp guard prevents a reload loop
// if the asset is genuinely broken.
const RELOAD_KEY = 'chunk-reload-at'
const RELOAD_GUARD_MS = 10_000

export function reloadForStaleChunk(reason: unknown, targetUrl?: string): boolean {
  let last = 0
  try {
    last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
  } catch {
    // sessionStorage unavailable — still allow a single reload
  }
  if (Date.now() - last < RELOAD_GUARD_MS) return false

  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    // ignore
  }
  console.log('Stale build chunk failed to load, reloading to fetch the new version', reason)
  if (targetUrl) {
    window.location.assign(targetUrl)
  } else {
    window.location.reload()
  }
  return true
}

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error)
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(
    message,
  )
}
